import { render } from "./Eggs.vue?vue&type=template&id=1fddc40a&scoped=true"
import script from "./Eggs.vue?vue&type=script&lang=js"
export * from "./Eggs.vue?vue&type=script&lang=js"

import "./Eggs.vue?vue&type=style&index=0&id=1fddc40a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fddc40a"

export default script